import { useState, useCallback } from 'react';
import { remote_CollectRestoreTransaction_downloadFreePhotoFile } from '~/common/typescript/apis/CollectSyncTransactionAPIs';
import { message } from 'antd';

/**
 * Custom hook for downloading FreePhoto files
 */
export const useFreePhotoDownload = () => {
  const [downloading, setDownloading] = useState(false);

  const downloadPhoto = useCallback(async (uuid: string, fileName: string) => {
    setDownloading(true);
    try {
      // Fetch the blob from the API
      const blob = await remote_CollectRestoreTransaction_downloadFreePhotoFile(uuid);

      // Create a download link
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();

      // Cleanup
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      message.success('Ảnh đã được tải xuống');
    } catch (error) {
      console.error('Failed to download photo:', error);
      message.error('Không thể tải xuống ảnh');
    } finally {
      setDownloading(false);
    }
  }, []);

  return {
    downloadPhoto,
    downloading,
  };
};
